import { Helmet } from "react-helmet";

type SEOProps = {
  title: string;
  description: string;
  path?: string;
  noindex?: boolean;
};

const SITE_URL = "https://forteestateadvisory.com";

export default function SEO({ title, description, path = "/", noindex = false }: SEOProps) {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
}